module.exports = __webpack_public_path__ + "img/right3.2ec1c603.png";